<div
    class="grid grid-cols-2 gap-2 w-full text-sm space-x-14 xl:flex xl:ml-3 xl:mt-2 xl:space-x-4"
>
    <div>
        App ID:
        <span class="text-primary-800">{{ appId$ | async }}</span>
    </div>
    @if (shouldShowEwaStaffHeaderFields()) {
        @if (applicationState$ | async; as state) {
            @if (licenseeName$ | async; as licenseeName) {
                <div>
                    Customer:
                    <span class="text-primary-800">{{ licenseeName }}</span>
                </div>
            }
            <div>
                Credit Approved:
                <span
                    class="{{
                        state.applicationUserInformation?.isCreditApproved
                            ? 'text-success-700'
                            : 'text-error-700'
                    }}"
                >
                    {{
                        state.applicationUserInformation?.isCreditApproved
                            ? 'Yes'
                            : 'No'
                    }}
                </span>
            </div>
            <div>
                Membership:
                <span
                    class="{{
                        isActiveUserMembershipStatus(
                            state.applicationUserInformation?.membershipStatus
                        )
                            ? 'text-success-700'
                            : 'text-error-700'
                    }}"
                >
                    {{
                        getFormattedUserMembershipStatusLabel(
                            state.applicationUserInformation?.membershipStatus
                        )
                    }}
                </span>
            </div>
        }
    }
</div>
